@if (isAdmin) {
  <button
    mat-icon-button
    [matTooltip]="isImpersonating ? 'Exit impersonation mode' : 'Impersonate non-admin user'"
    color="accent"
    (click)="toggleImpersonation()">
    <mat-icon>{{ isImpersonating ? 'person' : 'person_off' }}</mat-icon>
  </button>
}
